"use client"

import { useCallback } from "react"
import type { PageViewParams } from "@/lib/mautic-campaign-tags"

declare global {
   interface Window {
      mt?: (...args: unknown[]) => void
   }
}

export function useMauticTracking() {
   const trackPageView = useCallback((params: PageViewParams) => {
      if (typeof window === "undefined" || typeof window.mt !== "function") return

      window.mt("set", "id", null)

      const payload: Record<string, unknown> = {
         mt_event: params.mt_event,
         page_title: params.page_title,
         page_url: params.page_url,
         tags: params.tags,
         lead_only: 1,
      }
      if (params.email) payload.email = params.email

      window.mt("send", "pageview", payload)
   }, [])

   const trackEvent = useCallback((category: string, action: string, label?: string) => {
      if (typeof window === "undefined" || typeof window.mt !== "function") return
      window.mt("send", "event", { category, action, ...(label ? { name: label } : {}) })
   }, [])

   return { trackPageView, trackEvent }
}
